import { AnimatePresence, motion, useReducedMotion } from 'motion/react';
import React from 'react';
import styled from 'styled-components';

const OwnAiTitleStyles = styled(motion.h3)`
  body.dark & {
    color: #fff;
  }

  color: #000;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  margin: 8px 0 40px;
  padding: 0 16px;
`;

export const OwnAiTitle = React.forwardRef<
  HTMLHeadingElement,
  React.PropsWithChildren<{
    children: NonNullable<React.ReactNode>;
    className?: string;
    animate?: boolean;
    show?: boolean;
  }>
>(function OwnAiTitle({ children, className, animate, show }, ref) {
  const shouldReduceMotion = useReducedMotion();
  const canAnimate = animate && !shouldReduceMotion;

  if (canAnimate) {
    return (
      <AnimatePresence>
        {show && (
          <OwnAiTitleStyles
            ref={ref}
            className={className}
            variants={{
              initial: { opacity: 0, y: 50 },
              visible: { opacity: 1, y: 0 },
              exit: { opacity: 0, y: 50 },
            }}
            initial="initial"
            animate="visible"
            exit="exit"
            transition={{ duration: 0.3 }}
          >
            {children}
          </OwnAiTitleStyles>
        )}
      </AnimatePresence>
    );
  }

  return (
    <OwnAiTitleStyles ref={ref} className={className}>
      {children}
    </OwnAiTitleStyles>
  );
});

const OwnAiTitleHighlightStyles = styled.span`
  border-radius: 7px;
  color: #ff0eed;
  padding: 4px 2px;
`;

export const OwnAiTitleHighlight: React.FC<{
  children?: NonNullable<React.ReactNode>;
  className?: string;
}> = ({ children, className }) => {
  return (
    <OwnAiTitleHighlightStyles className={className}>
      {children}
    </OwnAiTitleHighlightStyles>
  );
};
